<template lang="pug">
  r-table( 
    ref='table'
    no-search 
    v-bind='tableProps' 
    @detail='submitUpdate'
    @remove='submitDelete'
    )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import HrContractStructureFilters from '@/views/HumanResource/HrContractStructure/HrContractStructureFilters'
  import HrContractStructureHeaders from '@/views/HumanResource/HrContractStructure/HrContractStructureHeaders'
  import HrContractStructureService from '@/services/api/HumanResource/HrContractStructure'
  //
  export default {
    components: {
      RTable,
    },
    computed: {
      tableProps() {
        return {
          filters: HrContractStructureFilters,
          headers: HrContractStructureHeaders,
          service: HrContractStructureService.toList(),
        }
      },
    },
    data() {
      return {
        selected: null,
      }
    },
    methods: {
      showDeleteError() {
        this.showErrorSnackbar('No se pudo eliminar.')
      },
      showDeleteSuccess() {
        this.showSuccessSnackbar('Contracto tipo eliminado.')
      },
      submitCreate() {
        this.$router.push({ name: 'contract-structure-create' })
      },
      submitDelete(event) {
        //
        this.selected = event.item
        //
        this.showWarningSnackbar({
          title: 'Eliminar contracto tipo',
          message: 'Una vez eliminado no se puede recuperar.',
          confirm: 'eliminar',
        })
      },
      submitUpdate(event) {
        this.$router.push({ name: 'contract-structure-update', params: { id: event.item.id } })
      },
      toDelete() {
        return this
          .selected
          .delete()
          .then(this.showDeleteSuccess)
          .then(this.toRefresh)
          .catch(this.showDeleteError)
      },
      toRefresh() {
        return this
          .$refs
          .table
          .refresh()
      },
    },
    watch: {
      responseConfirmSnackbar(value) {
        switch(value) {
          case 'eliminar': return this.toDelete()
        }
      }
    },
    created() {
      this.setItems([
        {
          text: 'crear contrato tipo',
          icon: 'add_circle',
          action: this.submitCreate,
        }
      ])
    },
    mounted() {
      this.setTitle('Contratos tipo')
    },
    beforeRouteEnter(to, from, next) {
      next(ctx => {
        if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
      })
    },
  }
</script>
